// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.group[data-v-a548d260] {\n  padding-bottom: 1rem;\n}\n.group + .group[data-v-a548d260] {\n  border-top: 2px solid var(--border-bottom);\n  padding-top: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
